import { UrlTree } from '@angular/router';
import { AnimationOptions } from '@ionic/angular/common/providers/nav-controller';
import { Action } from '@ngrx/store';
import { CorePageModuleIDs } from './core.models';

export enum CoreRouterActionsTypes {
  GO_BACK = '[CoreRouterAction] Go back',
  NAVIGATE_BACK = '[CoreRouterAction] Navigate back',
  NAVIGATE_FORWARD = '[CoreRouterAction] Navigate forward',
  NAVIGATE_ROOT = '[CoreRouterAction] Navigate root',
  NAVIGATE_TO_MODULE = '[CoreRouterAction] Navigate to module',
  NAVIGATE_TO_FIRST_MODULE = '[CoreRouterAction] Navigate to first module',
  NAVIGATE_TO_PAGE_MODULE = '[CoreRouterAction] Navigate to page module',
  NOOP = '[CoreRouterAction] Noop'
}

export enum CoreRouterNavigationIntent {
  BACK,
  FORWARD,
  ROOT
}

export class CoreRouterActionGoBack implements Action {
  readonly type = CoreRouterActionsTypes.GO_BACK;

  constructor(public payload?: AnimationOptions) {}
}

export class CoreRouterActionNavigateBack implements Action {
  readonly type = CoreRouterActionsTypes.NAVIGATE_BACK;

  constructor(
    public payload: {
      url: string | UrlTree | any[];
      options?: AnimationOptions;
    }
  ) {}
}

export class CoreRouterActionNavigateForward implements Action {
  readonly type = CoreRouterActionsTypes.NAVIGATE_FORWARD;

  constructor(
    public payload: {
      url: string | UrlTree | any[];
      options?: AnimationOptions;
    }
  ) {}
}

export class CoreRouterActionNavigateRoot implements Action {
  readonly type = CoreRouterActionsTypes.NAVIGATE_ROOT;

  constructor(
    public payload: {
      url: string | UrlTree | any[];
      options?: AnimationOptions;
    }
  ) {}
}

export class CoreRouterActionNavigateToPageModule implements Action {
  readonly type = CoreRouterActionsTypes.NAVIGATE_TO_PAGE_MODULE;

  constructor(
    public payload: {
      id: CorePageModuleIDs;
      intent?: CoreRouterNavigationIntent;
      asRoot?: boolean;
      pageIndex?: number;
    }
  ) {}
}

export type CoreRouterActions =
  | CoreRouterActionGoBack
  | CoreRouterActionNavigateBack
  | CoreRouterActionNavigateForward
  | CoreRouterActionNavigateRoot
  | CoreRouterActionNavigateToPageModule;
